<template>
    <span v-if="tag === 'span'" :class="customClass">{{ text }}</span>
    <p v-else-if="tag === 'p'">{{ text }}</p>
    <h3 v-else-if="tag ==='h3'" :class="customClass"><a :href="url">{{ text }}</a></h3>
</template>

<script>
require('jquery')
window.jQuery = window.$ = jQuery

/* Import Jquery Plugins */
require('@/assets/theme/bkkmenu-2017/assets/js/dotdotdot/jquery.dotdotdot.min.js')
// require('dotdotdot-js')
/* Import Jquery Plugins */

export default {
  name: 'TagWithDotDotDot',
  mounted () {
    this.$nextTick(() => {
      //
      let obj = this.$el
      setTimeout(function () {
        $(obj).dotdotdot({
          ellipsis: '...',
          wrap: 'letter',
          fallbackToLetter: true,
          watch: true,
          after: '.ic'
        })
      }, 200)
    })
  },
  props: {
    text: String,
    tag: String,
    url: String,
    customClass: String
  }
}
</script>
